import { Phone, ChevronRight } from "lucide-react";
import { Button } from "../components/ui/button";
export default function HeroSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative pt-20 md:pt-24 pb-16 md:pb-24 bg-white overflow-hidden hero-gradient">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid md:grid-cols-2 items-center gap-8 md:gap-12">
          {/* Left content */}
          <div>
            <div className="hero-badge hero-badge-shimmer inline-flex items-center gap-2 bg-green-50 border border-green-200 text-[#6AB023] rounded-full px-4 py-1.5 text-sm font-medium mb-6">
              <span className="w-2 h-2 bg-[#6AB023] rounded-full animate-pulse"></span>
              Lot-et-Garonne (47)
            </div>
            <h1
              className="hero-title text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-6"
              data-testid="hero-title">
              <span className="text-[#6AB023]">Votre expert en</span>
              <span className="block text-gray-900">pompe à chaleur &<br />climatisation</span>
            </h1>
            <p className="hero-subtitle text-base md:text-lg text-gray-600 leading-relaxed mb-8 max-w-lg">Installateur de pompes à chaleur, chauffe-eau thermodynamique et climatisation réversible en Lot-et-Garonne. Certifié RGE QualiPAC, 500+ installations, devis gratuit.
            </p>
            <div className="hero-cta flex flex-col sm:flex-row gap-3">
              <Button
                onClick={scrollToContact}
                className="btn-shine bg-[#6AB023] hover:bg-[#5a9a1e] text-white font-bold rounded-full h-13 px-8 text-base gap-2 hover:scale-105 transition-transform"
                data-testid="hero-cta-devis">
                Devis gratuit
                <ChevronRight className="w-5 h-5" />
              </Button>
              <Button
                asChild
                variant="outline"
                className="border-[#6AB023] text-[#6AB023] hover:bg-green-50 font-semibold rounded-full h-13 px-8 text-base gap-2 w-full sm:w-auto hover:scale-105 transition-transform"
                data-testid="hero-cta-phone">
                <a href="tel:0628514915">
                  <Phone className="w-5 h-5" />
                  06 28 51 49 15
                </a>
              </Button>
            </div>
            {/* Trust badges */}
            <div className="hero-trust flex flex-wrap items-center gap-6 mt-10 text-sm text-gray-500">
              {["Devis gratuit", "Intervention rapide", "Certifié RGE QualiPAC"].map((badge) =>
              <div key={badge} className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#6AB023]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  {badge}
                </div>
              )}
            </div>
          </div>
          {/* Right image */}
          <div className="hero-image">
            <div className="relative hero-image-float">
              <div className="absolute -inset-4 bg-gradient-to-br from-[#6AB023]/10 to-transparent rounded-3xl"></div>
              <img
                src="https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/d8avbt7b_IMG_8167.jpeg"
                alt="Alter Energies - Installation pompe à chaleur et climatisation en Lot-et-Garonne (47) - Chauffagiste RGE QualiPAC"
                className="relative rounded-2xl shadow-xl w-full h-auto object-cover aspect-[4/3]"
                data-testid="hero-image" />
            </div>
          </div>
        </div>
      </div>
    </section>);
}
